import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const premiumLandingPageEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "async-premium-landing-page" */ './src/ui'),
	),
	getPreloadProps: () => ({}),
});
